import { FC, useState, useEffect, useCallback } from "react";
import "./index.css";
import { IDataRequest, apiNoLoading, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import WhatsAppIcon from "./WhatAppIcon";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
export interface WhatsAppButtonProperties {    
    userId: number;
    isIntelbras: boolean;
}
const WP_BASE_PATH = "https://api.whatsapp.com/send?phone=55";
const ESTADO_PADRAO = "SC"; //solicitação Jira SOL-472 - definição do estado padrão de whatsapp para usuários internos.

const WhatsAppButton: FC<WhatsAppButtonProperties> = ({
    userId,
    isIntelbras
}) => {
    const [phoneState, setPhoneState] = useState<any>();
    const [cidade, setCidade] = useState<any>();
    const [estado, setEstado] = useState<any>();

    const loadCity = useCallback(async() => {
        if(!isIntelbras){
            const request: IDataRequest = {
                url: `/cadastros/contas?id=${userId}`
            }
            apiNoLoading.get(request).then((response: IDataResponse) => {
                if (response.statusCode === STATUS_CODE.OK) {
                    setCidade(response.data[0].cidade_id);
                } else {
                    setCidade(null);
                }
            });
        } else {
            setEstado(ESTADO_PADRAO);
        }
    },[userId, isIntelbras]);
    const loadEstado = useCallback(async() => {
        const request: IDataRequest = {
            url: `/cidades?id=${cidade}`
        }
        apiNoLoading.get(request).then((response: IDataResponse) => {
            if (response.statusCode === STATUS_CODE.OK) {
                setEstado(response.data[0].estado_id);
            } else {
                setEstado(null);
            }
        });
    },[cidade]);
    const loadRegiao = useCallback(async() => {
        const permissoes:string[] = PermissionUtil.getPermissions();
        if (!PermissionUtil.can(PermissionUtil.PERMISSION_TELEFONES_LISTAGEM, permissoes)) {
            return;
        }
        const request: IDataRequest = {
            url: `/cadastros/telefones`
        }
        apiNoLoading.get(request).then((response: IDataResponse) => {
            if (response.statusCode === STATUS_CODE.OK) {
                const data = response.data;
                data?.forEach((phone:any) => {
                    phone?.telefones_regioes?.forEach((regiao:any) => {
                        if (regiao?.nome === estado && !regiao?.deleted_at) {
                            setPhoneState(phone.numero);
                        }
                    });
                });
            }
        });
    },[estado]);
    
    useEffect(()=>{
        if (userId) {
          loadCity();
        }
    },[userId, loadCity]);

    useEffect(()=>{
        if (cidade) {
            loadEstado();
        }
    },[cidade, loadEstado]);

    useEffect(()=>{
        if (estado) {
            loadRegiao();
        }
    },[estado, loadRegiao]);

    return (
        <>
            {phoneState &&(
                <WhatsAppIcon 
                    url={`${WP_BASE_PATH+phoneState}`}
                />
            )}
        </>
    )
}

export default WhatsAppButton;